import style from './SearchBox.css';
import SearchIcon from '../Icons/SearchIcon';
import { _className } from '../../../utils/classname.utils';
import ClearIcon from '../Icons/ClearIcon';

export default function SearchBox({
  className = '',
  placeholder = '',
  disabled = false,
  value,
  onChange,
  onClear,
}) {
  return (
    <div className={`${className} ${style.container}`}>
      <SearchIcon
        className={`${style.icon} ${style['icon--search']} ${_className(
          disabled,
          style['icon--disabled'],
        )}`}
      />
      <input
        type={'text'}
        placeholder={placeholder}
        className={style.input}
        disabled={disabled}
        value={value}
        onInput={onChange}
      />
      {value && (
        <ClearIcon
          onClick={onClear}
          className={`${style.icon} ${style['icon--clear']} ${_className(
            disabled,
            style['icon--disabled'],
          )}`}
        />
      )}
    </div>
  );
}
